import { createFileRoute } from '@tanstack/react-router';
import SupportFAQ from '@pages/Support/SupportFAQ';

export const Route = createFileRoute('/support/support-faq')({
  validateSearch: (search) => ({
    search: typeof search.search === 'string' ? search.search : '',
  }),
  component: SupportFAQ,
});
